import allUsersDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const allUsersReducer = allUsersDispatcher(initialState, {
  [allUsersDispatcher.getAllUsersSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [allUsersDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default allUsersReducer;
